import { zodResolver } from '@hookform/resolvers/zod';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@optools/components/ui/form';
import { Input } from '@optools/components/ui/input';
import { useForm } from 'react-hook-form';
import * as z from 'zod';

const schema = z.object({
  email: z.email({ error: 'Please enter a valid email address' }),
});

export type UserInfoFormValues = z.infer<typeof schema>;

export interface UserInfoSearchProps {
  loading: boolean;
  onSubmit: (email: string) => void;
}

export function UserInfoSearch({ loading, onSubmit }: UserInfoSearchProps) {
  const form = useForm<UserInfoFormValues>({
    defaultValues: { email: '' },
    disabled: loading,
    resolver: zodResolver(schema),
    reValidateMode: 'onSubmit',
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(({ email }) => onSubmit(email))}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem className="max-w-md">
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
